var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.showClosePopUp) +
          " " +
          _vm._s(_vm.getConfirmBoxResponse) +
          " "
      ),
      _vm.showlist
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-mask upl-holdNEW wdth-700",
                    staticStyle: { "overflow-y": "auto", display: "block" },
                  },
                  [
                    _c("div", { staticClass: "modal-wrapper" }, [
                      _c("div", { staticClass: "modal-container" }, [
                        _c(
                          "div",
                          { staticClass: "modal-header" },
                          [
                            _vm._t("header", function () {
                              return [
                                _c("h4", { staticClass: "modal-title mt-2" }, [
                                  _vm._v("Uploaded files"),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close up-close",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.closePopUp("goBack")
                                      },
                                    },
                                  },
                                  [_vm._v("×")]
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm.filelist && _vm.filelist.length > 0
                          ? _c("div", { staticClass: "modal-body" }, [
                              _c("div", { staticClass: "fileulpd-sec" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _vm.filelist.length > 1
                                      ? _c(
                                          "p",
                                          { staticClass: "sub-head-uplmodal" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.filelist.length +
                                                  " Files uploaded"
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "p",
                                          { staticClass: "sub-head-uplmodal" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.filelist.length +
                                                  " File uploaded"
                                              )
                                            ),
                                          ]
                                        ),
                                  ]),
                                  _c("div", { staticClass: "col-md-6" }, [
                                    !_vm.isEncounterActive
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "p-blue1 sub-head-uplmodal pull-right",
                                          },
                                          [_vm._v("This encounter is closed")]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "filelisthold" },
                                _vm._l(_vm.filelist, function (item) {
                                  return _c(
                                    "div",
                                    { staticClass: "row upl-hover" },
                                    [
                                      _c("div", { staticClass: "col-9" }, [
                                        _c(
                                          "div",
                                          { staticClass: "test-reports-right" },
                                          [
                                            _c("button", {
                                              staticClass:
                                                "btn btn-downloadico",
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "filename" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-6",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "down-link tkout-wrap",
                                                            attrs: {
                                                              href: _vm.getdownloadfileUrl,
                                                              "data-toggle":
                                                                "tooltip",
                                                              title:
                                                                item.report_actual_name,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.viewFile(
                                                                  item.report_file_key,
                                                                  "file",
                                                                  item.report_actual_name
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "down-link tkout-wrap",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.textEllipsis(
                                                                      item.report_actual_name,
                                                                      _vm.truncatelength
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-6 px-0",
                                                      },
                                                      [
                                                        item.uploaded_date
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "timehold text-right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.uploaded_date
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "col-3 pl-4 pr-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "modal-upl-hold" },
                                            [
                                              _c("ul", [
                                                _c(
                                                  "li",
                                                  { staticClass: "pt-1" },
                                                  [
                                                    _c("a", {
                                                      staticClass:
                                                        "action-view",
                                                      attrs: {
                                                        href: _vm.getdownloadfileUrl,
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-original-title":
                                                          "View",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.viewFile(
                                                            item.report_file_key,
                                                            "file",
                                                            item.report_actual_name
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        !(_vm.filelist && _vm.filelist.length)
                          ? _c(
                              "div",
                              {
                                staticClass: "modal-body",
                                staticStyle: { "text-align": "center" },
                              },
                              [
                                _vm._v(
                                  "\n              No files have been added so far.\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "modal fade imgPreview",
                            attrs: {
                              id: "viewbalance",
                              role: "dialog",
                              tabindex: "-1",
                              "aria-modal": "true",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "modal-dialog modal-lg" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "modal-content file-content" },
                                  [
                                    _c("div", { staticClass: "modal-header" }, [
                                      _c("h3", {
                                        staticClass: "modal-title mb-4",
                                      }),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "close",
                                          attrs: {
                                            type: "button",
                                            "data-dismiss": "modal",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              ×\n            "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "modal-body" }, [
                                      _c("div", {}, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getdownloadfileUrl,
                                            alt: "",
                                          },
                                        }),
                                        _c("div"),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  datamessage: _vm.sucessmsgtext,
                  isVisible: _vm.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ConfirmBox", {
        ref: "confirmcomp",
        attrs: { showmodal: _vm.showCnfrmPopUp, actionmessage: _vm.actionMsg },
        on: {
          cancelAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = false
          },
          confirmAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = true
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }